"use client";

import React from "react";

interface HeadingProps {
  children: React.ReactNode;
  level?: "h1" | "h2" | "h3"; // Allowed heading levels
  className?: string;
}

const Heading: React.FC<HeadingProps> = ({ children, level = "h2", className = "" }) => {
  const HeadingTag = level === "h1" ? "h1" : level === "h2" ? "h2" : "h3"; // Explicitly map levels
  return <HeadingTag className={`text-2xl font-bold text-gray-800 mt-2 ${className}`}>{children}</HeadingTag>;
};

export default Heading;